import { Injectable } from '@angular/core';
import { ApiService } from '../../api/api.service';
import { Observable } from 'rxjs';
import {
  BusinessLine,
  Product,
  Variant,
  CustomConfigurationResponse,
  MixingCodeValidationResponse,
} from '@interfaces';

@Injectable({
  providedIn: 'root',
})
export class ProductService {
  private url: string = 'Products';

  constructor(private apiService: ApiService) {}

  public getBusinessLines(): Observable<BusinessLine[]> {
    return this.apiService.get(`${this.url}/business-lines`);
  }

  public getProducts(businessLineId: number): Observable<Product[]> {
    return this.apiService.get(`${this.url}/business-lines/${businessLineId}`);
  }

  public getVariants(productId: string): Observable<Variant[]> {
    return this.apiService.get(`${this.url}/${productId}/variants`);
  }

  public getCustomConfiguration(): Observable<CustomConfigurationResponse> {
    return this.apiService.get(`${this.url}/custom-configuration`);
  }

  public validateMixingCode(
    mixingCode: string,
  ): Observable<MixingCodeValidationResponse> {
    return this.apiService.get(
      `${this.url}/variants/by-mixing-code/${mixingCode}`,
    );
  }
}
